export { default as PrismicImageWithAlt } from './PrismicImageWithAlt';
